// ============================================
// UPLOAD SETTINGS SERVICE
// ============================================

import api from './api';

const API_BASE = '/admin/upload-settings';

const uploadSettingsService = {
    // Get current upload settings (admin only)
    getSettings: async () => {
        const response = await api.get(API_BASE);
        return response.data.settings;
    },

    // Get public upload settings (all authenticated users)
    // Returns max_file_size_mb and allowed_extensions
    getPublicSettings: async () => {
        const response = await api.get(`${API_BASE}/public`);
        return response.data;
    },

    // Update upload settings (admin only)
    updateSettings: async (data) => {
        const response = await api.put(API_BASE, data);
        return response.data;
    },

    // Get default extension categories (admin only)
    getDefaultExtensions: async () => {
        const response = await api.get(`${API_BASE}/defaults`);
        return response.data.categories;
    }
};

export default uploadSettingsService;

